const FUNDER_BREAD_CRUMB_EN = {
    'common.bread-crumb.home': 'Home',
    'common.bread-crumb.marketplace': 'Marketplace',
    'common.bread-crumb.receivables': 'Assets',
    'common.bread-crumb.overview': 'Overview',
    'common.bread-crumb.seller-statistics': 'Seller Profile',
    'common.bread-crumb.profile': 'Profile & Settings',
    'common.bread-crumb.balance-asset': 'Balance & Assets',
    'common.bread-crumb.404': 'Page Not Found',
    'common.bread-crumb.account-summary': 'Account Summary',
    'common.bread-crumb.asset-management': 'Asset Management',
    'common.bread-crumb.transaction-details': 'Transaction Details',
    'common.bread-crumb.report': 'Report',
};

const FUNDER_BREAD_CRUMB_ZH_TW = {
    'common.bread-crumb.home': '首頁',
    'common.bread-crumb.marketplace': '市場',
    'common.bread-crumb.receivables': '資產',
    'common.bread-crumb.overview': '概覽',
    'common.bread-crumb.seller-statistics': '賣方資料',
    'common.bread-crumb.profile': '個人資料與設定',
    'common.bread-crumb.balance-asset': '餘額與資產',
    'common.bread-crumb.404': '沒有相關頁面',
    'common.bread-crumb.account-summary': '帳戶摘要',
    'common.bread-crumb.asset-management': '資產管理',
    'common.bread-crumb.transaction-details': '交易明細',
    'common.bread-crumb.report': '報告',
};


export {
    FUNDER_BREAD_CRUMB_EN,
    FUNDER_BREAD_CRUMB_ZH_TW
}